<span [formGroup]="internalGroup">
  <mat-form-field appearance="outline">
    <mat-label>{{label}}</mat-label>
    <mat-select formControlName="selection">
      <mat-option *ngFor="let hour of hourlyList; let i = index" [value]="i">{{hour.name}}</mat-option>
    </mat-select>
  </mat-form-field>
</span>
